import Button from "src/components/general/button/Button";
import Image from "next/image";
import ToggleButton from "src/components/general/toggleButton";
import React, { useState } from "react";
import {
  personalPricingOptions,
  toggleValuePremium,
  toggleValueUltimate,
} from "src/data/variables";
import { useAtom } from "jotai";
import { priceVariantAtom } from "src/atoms/pricingPage";
import { Badge } from "src/components/general/badge";
import { twc } from "react-twc";
import Link from "next/link";
export interface PriceCardsProps {
  isSeasonalDiscountActive: boolean;
}

/* FOOTER COMPONENTS*/
const FooterWrapper = twc.div`flex w-full flex-col items-center justify-center`;
const FooterDivider = twc.div`mt-3 h-[1px] w-[90%] bg-white-400`;
const FooterText = twc.p`mt-2 text-sm text-white-300`;

const PriceCards = ({ isSeasonalDiscountActive }: PriceCardsProps): React.JSX.Element => {
  const [priceVariant, setPriceVariant] = useAtom(priceVariantAtom);

  const [premiumToggleValue, SetPremiumToggleValues] = useState(
    personalPricingOptions.premiumYear.priceVariant,
  );
  const [ultimateToggleValue, SetUltimateToggleValues] = useState(
    personalPricingOptions.ultimateYear.priceVariant,
  );

  const [ultimatePrice, setUltimatePrice] = useState(personalPricingOptions.ultimateYear.cardPrice);
  const [ultimateDiscountPrice, setUltimateDiscountPrice] = useState(
    isSeasonalDiscountActive
      ? personalPricingOptions.ultimateYear.seasonalDiscountPrice
      : personalPricingOptions.ultimateYear.cardPrice,
  );
  const [ultimatePriceDecorator, setUltimatePriceDecorator] = useState(
    personalPricingOptions.ultimateYear.priceDecorator,
  );

  const [premiumPrice, setPremiumPrice] = useState(personalPricingOptions.premiumYear.cardPrice);
  const [premiumDiscountPrice, setPremiumDiscountPrice] = useState(
    isSeasonalDiscountActive
      ? personalPricingOptions.premiumYear.seasonalDiscountPrice
      : personalPricingOptions.premiumYear.cardPrice,
  );
  const [premiumPriceDecorator, setPremiumPriceDecorator] = useState(
    personalPricingOptions.premiumYear.priceDecorator,
  );

  const handlePremiumToggleChange = (value: string) => {
    SetPremiumToggleValues(value);
    switch (value) {
      case personalPricingOptions.premiumYear.priceVariant:
        setPremiumPrice(personalPricingOptions.premiumYear.cardPrice);
        setPremiumDiscountPrice(
          isSeasonalDiscountActive
            ? personalPricingOptions.premiumYear.seasonalDiscountPrice
            : personalPricingOptions.premiumYear.cardPrice,
        );
        setPremiumPriceDecorator(personalPricingOptions.premiumYear.priceDecorator);
        setPriceVariant(personalPricingOptions.premiumYear.priceVariant);
        break;
      case personalPricingOptions.premiumLifetime.priceVariant:
        setPremiumPrice(personalPricingOptions.premiumLifetime.cardPrice);
        setPremiumDiscountPrice(
          isSeasonalDiscountActive
            ? personalPricingOptions.premiumLifetime.seasonalDiscountPrice
            : personalPricingOptions.premiumLifetime.cardPrice,
        );
        setPremiumPriceDecorator(personalPricingOptions.premiumLifetime.priceDecorator);
        setPriceVariant(personalPricingOptions.premiumLifetime.priceVariant);
        break;
    }

    console.log(priceVariant);
  };

  const handleUltimateToggleChange = (value: string) => {
    SetUltimateToggleValues(value);
    switch (value) {
      case personalPricingOptions.ultimateMonth.priceVariant:
        setUltimatePrice(personalPricingOptions.ultimateMonth.cardPrice);
        setUltimateDiscountPrice(
          isSeasonalDiscountActive
            ? personalPricingOptions.ultimateMonth.seasonalDiscountPrice
            : personalPricingOptions.ultimateMonth.cardPrice,
        );
        setUltimatePriceDecorator(personalPricingOptions.ultimateMonth.priceDecorator);
        setPriceVariant(personalPricingOptions.ultimateMonth.priceVariant);
        break;
      case personalPricingOptions.ultimateYear.priceVariant:
        setUltimatePrice(personalPricingOptions.ultimateYear.cardPrice);
        setUltimateDiscountPrice(
          isSeasonalDiscountActive
            ? personalPricingOptions.ultimateYear.seasonalDiscountPrice
            : personalPricingOptions.ultimateYear.cardPrice,
        );
        setUltimatePriceDecorator(personalPricingOptions.ultimateYear.priceDecorator);
        setPriceVariant(personalPricingOptions.ultimateYear.priceVariant);
        break;
      case personalPricingOptions.ultimateLifetime.priceVariant:
        setUltimatePrice(personalPricingOptions.ultimateLifetime.cardPrice);
        setUltimateDiscountPrice(
          isSeasonalDiscountActive
            ? personalPricingOptions.ultimateLifetime.seasonalDiscountPrice
            : personalPricingOptions.ultimateLifetime.cardPrice,
        );
        setUltimatePriceDecorator(personalPricingOptions.ultimateLifetime.priceDecorator);
        setPriceVariant(personalPricingOptions.ultimateLifetime.priceVariant);
        break;
    }
  };

  const priceFor = (key: keyof typeof personalPricingOptions) => {
    const amount = isSeasonalDiscountActive
      ? personalPricingOptions[key].seasonalDiscountFullPrice
      : personalPricingOptions[key].fullPrice;

    return `$${amount.toFixed(2)}`;
  };

  return (
    <div className="mt-32 flex w-full items-center justify-center">
      <div className="flex w-11/12 flex-wrap items-center justify-center gap-20 md:w-3/4">
        <div className="h-auto min-h-[50.5rem] w-11/12 min-w-[25rem] max-w-[35rem] shrink-0 flex-col rounded-2xl border-4 border-white-50 lg:w-auto lg:flex-1">
          <div className="mt-10 flex items-center justify-between px-10 py-8 sm:gap-36">
            <h1>Free</h1>
            <Badge color="white" className="min-w-28 bg-white-50 text-black" size="big">
              Pay Nothing
            </Badge>
          </div>
          <div className="flex max-h-40 items-center justify-center">
            <Image
              alt="Redacto the cat as an astronaut"
              width={0}
              height={0}
              src="/images/pricing/personal/redacto-astronaut.svg"
              className="w-8/12"
            />
          </div>
          <div className="mt-10 flex items-center justify-center">
            <Link href="https://redact.dev/account" target="_blank" className="w-3/4">
              <Button
                color="white"
                raised={true}
                outlined={true}
                size="big"
                className="h-12 w-full font-bold text-xl"
              >
                Get an account
              </Button>
            </Link>
          </div>
          <div className="mt-10">
            <h3 className="flex justify-start bg-linear-to-r from-purple-100 to-blue-400 bg-clip-text px-5 font-bold text-sm text-transparent lg:text-lg">
              F E A T U R E &nbsp; H I G H L I G H T S
            </h3>
          </div>
          <div className="flex flex-col">
            <div className="flex items-center justify-start gap-1 px-5">
              <span className="icon-[material-symbols-light--post-add-rounded] h-6 w-6 bg-blue-300" />
              <p>Delete Tweets, Likes and Retweets</p>
            </div>
            <div className="flex items-center justify-start gap-1 px-5">
              <span className="icon-[material-symbols-light--edit-note] h-6 w-6 bg-blue-300" />
              <p>Obfuscate unlimited Reddit posts</p>
            </div>
            <div className="flex items-center justify-start gap-1 px-5">
              <span className="icon-[material-symbols-light--lock] h-6 w-6 bg-blue-300" />
              <p>Limited access to Discord and Facebook</p>
            </div>
            <div className="flex items-center justify-start gap-1 px-5">
              <span className="icon-[material-symbols-light--desktop-windows] h-6 w-6 bg-blue-300" />
              <p>Desktop and mobile app included!</p>
            </div>
          </div>
          <FooterWrapper>
            <FooterDivider />
            <FooterText>It&apos;s free! Create your Redact account now!</FooterText>
          </FooterWrapper>
        </div>

        <div className="h-auto min-h-[50.5rem] w-11/12 min-w-[25rem] max-w-[35rem] shrink-0 flex-col rounded-2xl border-4 border-blue-400 border-t-54 lg:w-auto lg:flex-1">
          <h2 className="-mt-12 z-50 w-full items-center justify-center text-center">
            Most Popular
          </h2>
          <div className=" flex items-center justify-between 3xl:gap-36 gap-20 px-10 py-6">
            <h1>Premium</h1>
            <Badge
              color="blue"
              className={`min-w-24 bg-blue-400 text-white ${isSeasonalDiscountActive ? "" : "hidden"}`}
              size="big"
            >
              Save {personalPricingOptions.premiumYear.seasonalDiscount}
            </Badge>
          </div>
          <ToggleButton
            isTransparent={true}
            ToggleValues={toggleValuePremium}
            DefaultValue={personalPricingOptions.premiumYear.priceVariant}
            OnValueChange={handlePremiumToggleChange}
            buttonColor="data-[state=on]:text-blue-400 text-xl"
          />
          <div className="mt-16 px-10">
            <span
              className={`ml-0.5 flex w-full items-start justify-start text-[14px] text-white-200 line-through ${isSeasonalDiscountActive ? "" : "hidden"}`}
            >
              {premiumPrice}
            </span>
            <span
              className={`flex ${isSeasonalDiscountActive ? "mt-2" : "mt-9"} w-full items-start justify-start text-[32px] text-white-100`}
            >
              {premiumDiscountPrice}&nbsp;
              <span className="mt-2 text-[16px] text-white-200">{premiumPriceDecorator}</span>
            </span>
          </div>
          <div className="mt-10 flex items-center justify-center">
            <Link href="https://redact.dev/account" target="_blank" className="w-3/4">
              <Button
                color="blue"
                raised={true}
                outlined={false}
                size="big"
                className="h-12 w-full font-bold text-xl"
              >
                Get Premium
              </Button>
            </Link>
          </div>
          <div className="mt-10">
            <h3 className="flex justify-start bg-linear-to-r from-purple-100 to-blue-400 bg-clip-text px-5 font-bold text-sm text-transparent lg:text-lg">
              F E A T U R E &nbsp; H I G H L I G H T S
            </h3>
          </div>
          <div className="flex flex-col">
            <div className="flex items-center justify-start gap-1 px-5">
              <span className="icon-[material-symbols-light--check-circle] h-6 w-6 bg-blue-300" />
              <p>Everything in free plan +</p>
            </div>
            <div className="flex items-center justify-start gap-1 px-5">
              <span className="icon-[material-symbols-light--heart-check-rounded] h-6 w-6 bg-blue-300" />
              <p>Delete from all supported social services</p>
            </div>
            <div className="flex items-center justify-start gap-1 px-5">
              <span className="icon-[material-symbols-light--post-add-rounded] h-6 w-6 bg-blue-300" />
              <p>Delete unlimited tweets, likes and retweets</p>
            </div>
            <div className="flex items-center justify-start gap-1 px-5">
              <span className="icon-[material-symbols-light--desktop-windows] h-6 w-6 bg-blue-300" />
              <p>Desktop and mobile app included!</p>
            </div>
          </div>
          <FooterWrapper>
            <FooterDivider />
            <FooterText>
              {premiumToggleValue === personalPricingOptions.premiumYear.priceVariant
                ? `Billed at ${priceFor("premiumYear")} every 12 months`
                : ""}
            </FooterText>
          </FooterWrapper>
        </div>

        <div className="h-auto min-h-[50.5rem] w-11/12 min-w-[25rem] max-w-[35rem] shrink-0 flex-col rounded-2xl border-4 border-purple-200 lg:w-auto lg:flex-1">
          <div className="mt-10 flex items-center justify-between 3xl:gap-36 gap-20 px-10 py-8">
            <h1>Ultimate</h1>
            <Badge
              color="purple"
              className={`min-w-24 bg-purple-200 text-white-50 ${isSeasonalDiscountActive ? "" : "hidden"}`}
              size="big"
            >
              Save {personalPricingOptions.ultimateYear.seasonalDiscount}
            </Badge>
          </div>
          <ToggleButton
            isTransparent={true}
            ToggleValues={toggleValueUltimate}
            DefaultValue={personalPricingOptions.ultimateYear.priceVariant}
            OnValueChange={handleUltimateToggleChange}
            buttonColor="data-[state=on]:text-purple-200 text-xl"
          />
          <div className="mt-16 px-10">
            <span
              className={`ml-0.5 flex w-full items-start justify-start text-[14px] text-white-200 line-through ${isSeasonalDiscountActive ? "" : "hidden"}`}
            >
              {ultimatePrice}
            </span>
            <span
              className={`flex ${isSeasonalDiscountActive ? "mt-2" : "mt-9"} w-full items-start justify-start text-[32px] text-white-100`}
            >
              {ultimateDiscountPrice}&nbsp;
              <span className="mt-2 text-[16px] text-white-200">{ultimatePriceDecorator}</span>
            </span>
          </div>
          <div className="mt-10 flex items-center justify-center">
            <Link href="https://redact.dev/account" target="_blank" className="w-3/4">
              <Button
                color="purple"
                raised={true}
                outlined={false}
                size="big"
                className="h-12 w-full font-bold text-xl"
              >
                Get Ultimate
              </Button>
            </Link>
          </div>
          <div className="mt-10">
            <h3 className="flex justify-start bg-linear-to-r from-purple-100 to-blue-400 bg-clip-text px-5 font-bold text-sm text-transparent lg:text-lg">
              F E A T U R E &nbsp; H I G H L I G H T S
            </h3>
          </div>
          <div className="flex flex-col">
            <div className="flex items-center justify-start gap-1 px-5">
              <span className="icon-[material-symbols-light--check-circle] h-6 w-6 bg-blue-300" />
              <p>Everything in premium plan +</p>
            </div>
            <div className="flex items-center justify-start gap-1 px-5">
              <span className="icon-[material-symbols-light--cases-sharp] h-6 w-6 bg-blue-300" />
              <p>Delete from all work & productivity services</p>
            </div>
            <div className="flex items-center justify-start gap-1 px-5">
              <span className="icon-[material-symbols-light--folder-zip] h-6 w-6 bg-blue-300" />
              <p>Mod tools for discord and reddit</p>
            </div>
            <div className="flex items-center justify-start gap-1 px-5">
              <span className="icon-[material-symbols-light--desktop-windows] h-6 w-6 bg-blue-300" />
              <p>Desktop and mobile app included!</p>
            </div>
          </div>
          <FooterWrapper>
            <FooterDivider />
            <FooterText>
              {ultimateToggleValue === personalPricingOptions.ultimateYear.priceVariant
                ? `Billed at ${priceFor("ultimateYear")} every 12 months`
                : ""}
            </FooterText>
          </FooterWrapper>
        </div>
      </div>
    </div>
  );
};

export default PriceCards;
